import { createFromJS } from "../types";
import uniqueId from "../utils/uniqueId";
import repairPlainObject from "./repairPlainObject";
import repairTimelineRecord from "./repairTimelineRecord";

const plainJsToTimelineRecord = (obj, charWidthMap) => {
  const fileVersion = obj && obj.fileVersion ? obj.fileVersion : 0;
  const plainData = repairPlainObject(obj);

  if (charWidthMap) {
    plainData.characterWidthMap = charWidthMap;
  }

  const timelineRecord = createFromJS.TimelineRecord(plainData).set("projectId", uniqueId());
  const result = repairTimelineRecord(timelineRecord, fileVersion);
  return result;
};

export default {
  plainJsToTimelineRecord
};
